module.exports = __webpack_public_path__ + "img/19.f0a7320.png";